import React from 'react';
import { STACK_ALIGN, StackView } from "../../../StackView";
import { SIZE_L, SIZE_XL } from "../../../helpers";
import { Text } from "../../../Text";
import { View, VIEW_ALIGN, VIEW_DISTRIBUTION } from "../../../View";
import { DotsIcon } from './DotsIcon';
import { Icon } from "../../../Icon";
import { styles } from './styles';
export var emptyColumnsContentRenderer = function (customText) {
    var dotsIconMask = '{{dots}}';
    var text = customText ||
        "Select a column from the Column selection (" + dotsIconMask + ") to display records";
    var hasDotsIconMask = text.indexOf(dotsIconMask) >= 0;
    var textParts = text.split(dotsIconMask);
    return (React.createElement(StackView, { align: STACK_ALIGN.center, size: { height: SIZE_XL } },
        textParts[0] && React.createElement(Text, null, textParts[0]),
        hasDotsIconMask && (React.createElement(View, { align: VIEW_ALIGN.center, size: { width: SIZE_L, height: SIZE_L }, distribution: VIEW_DISTRIBUTION.center },
            React.createElement(Icon, { src: React.createElement(DotsIcon, { className: styles.icon }) }))),
        textParts[1] && React.createElement(Text, null, textParts[1])));
};
//# sourceMappingURL=emptyColumnsContentRenderer.js.map